<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="1200px">
      <material-card
        v-if="model"
        :title="$t('views.unionlocals.correct_union_local')"
        :color="$vuetify.theme.themes.light.primary"
        icon="spellcheck"
      >
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" v-if="item">
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                  <trans-textbox
                    v-model="item"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    field="Name"
                    class="required"
                  ></trans-textbox>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="4" lg="4">
                  <no-autocomplete-textfield
                    v-model="item.Number"
                    :label="$t('globals.number')"
                    :rules="[
                      $rules.alphanumeric,
                      $rules.dynamic.upToLength(5),
                      $rules.unionLocalNumberZeros,
                      rules.unique,
                      $rules.required,
                    ]"
                    class="required"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving || loading"
            text
            @click="$emit('close', false)"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving || loading"
            :disabled="!valid"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransTextbox from "@/components/TransTextbox.vue";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import ErrorHandler from "@/components/ErrorHandler";
import { translate2 } from "@/trans2";
export default {
  components: {
    TransTextbox,
    NoAutocompleteTextfield,
    ErrorHandler,
  },
  props: ["identityId", "model"],
  data() {
    return {
      valid: false,
      item: null,
      error: null,
      saving: false,
      snackbar: false,
      loading: false,
      rules: {
        unique: (v) => {
          console.log("unique validation", this.isNumberUnique);
          return this.originalNumber === this.item.Number || this.isNumberUnique || this.$t("validation.unique_number");
        },
      },
      isNumberUnique: true,
      uniqueNumberMonitor: null,
      originalNumber: null
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
  },
  watch: {
    model: {
      async handler(v) {
        console.log("model: ", v);
        if (v) {
          this.loading = true;
          try {
            this.item = (await this.getUnionLocalById({
              planIdentityId: this.selectedPlan.Id,
              identityId: this.identityId,
            })).data;
            this.originalNumber = this.item.Number;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
      immediate: true,
    },
    "item.Number": {
      async handler(v) {
        console.log("number is :", v, this.item, this.union);
        if (v === null || v === undefined) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.item.Identity.Union.Name,
          TradeCode: this.item.Identity.Union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
      immediate: true,
    },
    "item.Name": {
      async handler(v) {
        if (this.item.Number === null || this.item.Number === undefined) {
          return;
        }
        console.log("number is :", v, this.item, this.union);
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.item.Identity.Union.Name,
          TradeCode: this.item.Identity.Union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "correctUnionLocal",
      "getUnionLocalById",
      "checkUnionLocalNumberUnique",
    ]),
    async save() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.Name = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      delete item["@odata.context"];
      this.saving = true;
      item.IdentityId = this.identityId;
      try {
        await this.correctUnionLocal({
          planIdentityId: this.selectedPlan.Id,
          identityId: this.identityId,
          payload: item,
        });
        this.snackbar = true;
        this.$emit("close", true);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style></style>
